'use strict';
var { tns } = require("tiny-slider");
const urlHelper = require('../utils/urlHelper');
const curatedProduct = require('../product/curatedProduct');
const cartActions = require('../product/cartActions');
const loader = require('../components/loader');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else if ($('.pdp-variation-select .js-select-dropdown-below').val() !== '') {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    } else {
        pid = $('.add-to-cart').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
 function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled').removeClass('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
            $attrValue.addClass('disabled');
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
 function createCarousel(imgs, $productContainer) {
    var thumbNail = $productContainer.find('.slider-thumbnail');
    var carousel = $productContainer.find('.pdp-slider');
    $(thumbNail).empty()
    $(carousel).empty()
    for (var i = 0; i < imgs.length; i++) {
        $('<li class="list-inline-item img-thumbnail" data-nav="'+[i]+'" aria-controls="tns1"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></li>').appendTo($(thumbNail));
    }
    while(carousel.find('.tns-item').length < 2){
        for (i = 0; i < imgs.length; i++) {
            $('<div class="item tns-item"><img src="' + imgs[i].url + '" class="d-block img-fluid w-100" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel));
        }
    }
    $($(thumbNail).find('.img-thumbnail')).first().addClass('tns-nav-active');
    $($(carousel).find('.tns-item')).first().addClass('tns-slide-active');
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    var isQuickView = $productContainer.parents('.product-quickview').length >= 1;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
        $productContainer.data('pid', response.product.id);
    }

    // Update primary images
    if (!isQuickView) {
        var primaryImageUrls = response.product.images.large;
        createCarousel(primaryImageUrls, $productContainer);
    }

    // Update pricing
    updateProductPrices(response.product);

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}


/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.error-messaging').append(errorHtml);
}

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createCustomErrorNotification(message, linkText, modalId) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message +
        ' <a style="color:#c00; text-decoration: underline; cursor: pointer;" data-toggle="modal" data-target="#' + modalId + '">' +
        linkText + '</a>' + '</div>';

    $('.error-messaging').append(errorHtml);
}

function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                     { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Remove product linet items.
 * @param {*} uuidToRemove - ProductLineItem UUID.
 * @param {*} swapExistingToPrimary - A flag to swap other product to primary
 */
function removeProductLineItem(uuidToRemove, swapExistingToPrimary) {
    var $productToRemove = $('.js-selected-product-row .uuid-' + uuidToRemove);
    var $removeBtn = $productToRemove.find('.remove-product');
    var productID = $removeBtn.data('pid');
    var url = $removeBtn.data('action');
    var uuid = $removeBtn.data('uuid');

    if (typeof swapExistingToPrimary === 'undefined') {
        swapExistingToPrimary = true;
    }

    var urlParams = {
        pid: productID,
        uuid: uuid,
        swapExistingToPrimary: swapExistingToPrimary
    };

    url = urlHelper.appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        async: false,
        success: function (data) {
            if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                    $('.uuid-' + data.toBeDeletedUUIDs[i]).parent().remove();
                }
            }
            $('.js-mini-plp-container').data('remove-uuid', null);
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
            }
        }
    });
}

/**
 * Generates the modal window on the first call.
 *
 */
 function getModalHtmlElement() {
    if ($('#confirmFavoriteViewModal').length !== 0) {
        $('#confirmFavoriteViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="confirmFavoriteViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <a class="full-pdp-link" href=""></a>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Init Add To Cart Product functionality
 * @return {void}
 */
function addToCart() {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', handleAddToCart);

    $('body').on('product:replaceWithCurated', function() {
        if ($('.js-mini-plp-container').length > 0
            && $('.js-mini-plp-container').data('remove-uuid')) {
                var uuidToRemove = $('.js-mini-plp-container').data('remove-uuid');
                let swapExistingToPrimary = false;
                removeProductLineItem(uuidToRemove, swapExistingToPrimary);
        }
    });
}

/**
 * Handles Add To Cart Product functionality
 * @return {void}
 */
function handleAddToCart() {
    var addToCartUrl;
    var lookbuilderUrl;
    var pid;
    var pidsObj;
    var setPids;
    var lookBuilderPage = ($('.js-lookbuilder').length > 0);

    $('body').trigger('product:beforeAddToCart', this);

    if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
        setPids = [];

        $('.product-detail').each(function () {
            if (!$(this).hasClass('product-set-detail')) {
                setPids.push({
                    pid: $(this).find('.product-id').text(),
                    qty: $(this).find('.quantity-select').val(),
                    options: getOptions($(this))
                });
            }
        });
        pidsObj = JSON.stringify(setPids);
    }

    pid = getPidValue($(this));

    var $addToCartButton = $(this);
    var $productContainer = $(this).closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
    }

    addToCartUrl = getAddToCartUrl();

    lookbuilderUrl = $('.add-to-cart-url').data('urlredirect');

    let isPrimary = true;
    if ($('.js-primary-product').length > 0) {
        isPrimary = $('.js-primary-product').val() !== 'false' ? true : false;
    }

    var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: getChildProducts(),
        quantity: getQuantitySelected($(this)),
        isPrimary: isPrimary
    };

    if($('.purchase-option .option-btn.active').length > 0) {
        var purchaseOption = $('.purchase-option .option-btn.active').data('value');
        form.purchaseOption = purchaseOption;
    }

    if (!$('.bundle-item').length) {
        form.options = getOptions($productContainer);
    }

    // The cart size-change quickview stamps the line item it was opened for
    // on the modal; carry it so the server replaces exactly that item.
    var replaceUuid = $(this).closest('#quickViewModal').data('replace-uuid');
    if (replaceUuid) {
        form.replaceUuid = replaceUuid;
    }

    $(this).trigger('updateAddToCartFormData', form);

    if (addToCartUrl) {
        // Show a loading overlay and disable the add to cart button while
        // Cart-AddProduct is in flight on the PDP. Both are cleared by the
        // loader.stop() calls below (and left in place on the redirect branch
        // until the page navigates away). Skipped on the look builder, which
        // never stops/redirects here and has its own loading treatment.
        if (!lookBuilderPage) {
            loader.start(null, $addToCartButton);
        }

        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                if ($('.modal').length > 0) {
                    $('.modal').modal('hide');
                }

                $('body').trigger('product:afterAddToCart', data);

                if (data.error) {
                    loader.stop();
                    // Prevent multiple error message display.
                    $('.alert.valid-cart-error').remove();
                    if (data.eventDateError) {
                        createCustomErrorNotification(data.message, data.linkText, data.modalId);
                    } else {
                        createErrorNotification(data.message);
                    }
                    return;
                }

                if (data.modalTemplate) {
                    loader.stop();
                    $(data.modalTemplate).modal('show');
                    return;
                }

                if (!lookBuilderPage) {
                    if (lookbuilderUrl) {
                        window.location.href = lookbuilderUrl;
                    } else {
                        // No redirect target (e.g. set/bundle add-to-cart):
                        // clear the overlay instead of leaving it up on a no-op
                        // navigation.
                        loader.stop();
                    }
                }
            },
            error: function () {
                loader.stop();
            }
        });
    }
}

/**
 * Update product's pricing
 * @param {*} product - Product response
 */
function updateProductPrices(product) {
    $('.options-container .purchase-option .rent .price').html(createPriceTemplate(product.rentpriceDisplay));
    $('.options-container .purchase-option .buy .price').html(createPriceTemplate(product.buypriceDisplay));
}

/**
 * Create a product price dom template.
 * @param {*} productPrice - Product price
 * @returns String priceTemplate
 */
function createPriceTemplate(productPrice) {
    let priceTemplate = '';
    if (productPrice.salesPrice) {
        priceTemplate = '<span class="strike-through">' + productPrice.formatted + '</span>' + productPrice.salesPrice.formatted;
    } else {
        priceTemplate = productPrice.formatted;
    }

    return priceTemplate;
}

if ( $('.pdp-slider').length > 0 ) {
    var carouselContainer = tns({
        container: ".pdp-slider",
        items: 1,
        loop: false,
        navContainer: ".slider-thumbnail",
        navAsThumbnails: "true",
        mouseDrag: "true",
        swipeAngle: false,
        speed: 400
    });

    var makeSlideAccessible = function() {
        setTimeout(() => {
            $('.img-thumbnail')
            .attr('tabindex', 0)
            .attr('aria-hidden', false);
        }, 500);
    }

    let carouselNavInit = () => {
        // Set the default image carousel index.
        const urlParams = new URLSearchParams(window.location.search);
        const slideCount = carouselContainer.getInfo().slideCount;
        let imageStart = urlParams.get('image');

        if (imageStart && !isNaN(imageStart) && imageStart <= slideCount) {
            // Focus the carousel nav to the selected index.
            let itemsPerPage = carouselNav.getInfo().items;
            let slideClick = Math.ceil(imageStart / itemsPerPage);
            let i = 1;
            while (i < slideClick) {
                $('.slider-thumbnail-next').trigger('click');
                i++;
            }

            imageStart--;
            carouselContainer.goTo(imageStart);
        }

        makeSlideAccessible();
    }

    var carouselNav = tns({
        container: ".slider-thumbnail",
        items: 4,
        loop: false,
        speed: 400,
        axis: "vertical",
        mouseDrag: true,
        nav: false,
        arrowKeys: true,
        slideBy: "page",
        swipeAngle: false,
        center: false,
        gutter: 10,
        onInit: carouselNavInit,
        prevButton: '.slider-thumbnail-prev',
        nextButton: '.slider-thumbnail-next'
    });

    carouselNav.events.on('transitionEnd', makeSlideAccessible);
    $('.img-thumbnail').on('click keyup', makeSlideAccessible);

    // #16 — Keyboard-accessible zoom: forward click on the zoom button to the
    // active slide's .containerZoom (image-zoom plugin replaces <img> with that figure).
    $(document).on('click', '.js-zoom-trigger', function (e) {
        e.preventDefault();
        var $activeSlide = $('.pdp-slider .tns-slide-active');
        var $zoomTarget = $activeSlide.find('.containerZoom').first();
        if ($zoomTarget.length) {
            $zoomTarget.trigger('click');
        }
    });

    // #27 — Keep non-active carousel video controls out of the tab order.
    var refreshVideoTabbability = function () {
        $('.pdp-slider .tns-item').each(function () {
            var $slide = $(this);
            var $video = $slide.find('video');
            if (!$video.length) return;
            if ($slide.hasClass('tns-slide-active')) {
                $video.removeAttr('tabindex').removeAttr('aria-hidden');
            } else {
                $video.attr('tabindex', '-1').attr('aria-hidden', 'true');
            }
        });
    };
    refreshVideoTabbability();
    carouselContainer.events.on('indexChanged', refreshVideoTabbability);
    carouselContainer.events.on('transitionEnd', refreshVideoTabbability);
}

if ( $('.recommend-slider').length > 0 ) {
    var recommendContainer = tns({
        container: ".recommend-slider",
        items: 1,
        center: true,
        nav: false,
        gutter: 10,
        controlsContainer: "#customize-controls",
        swipeAngle: false,
        speed: 400,
        responsive: {
            640: {
                items: 2,
                mouseDrag: "true"
            },

            900: {
                items: 3,
            }
    }
    });
}

module.exports = {
    methods: {
        handleAddToCart: handleAddToCart
    },
    carouselContainer,
    recommendContainer,
    addToCart: addToCart,
    handleReplaceCuratedProduct: curatedProduct.handleReplaceCuratedProduct,
    handleCartActions: cartActions.handleCartActions,
    selectAttribute: function () {
        $(document).on('click', '.options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var button = $(this);
            if (!button.hasClass('option-btn')) {
                button.parents('.detail-option').find('.detail-option-btn-label').removeClass('active');
                button.toggleClass('active');

                attributeSelect(e.currentTarget.value, $productContainer);
            }
        });
    },
    sizeAttribute: function () {
        $('.rent-customize.rentContainer button.add-to-cart').attr('disabled', false);

        $(document).on('change', '.select-size', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            var currVal = $(this).val();
            var selectSizePlaceHolder = `${Resources.SELECT_SIZE}`;
            if (currVal && currVal !== selectSizePlaceHolder) {
                attributeSelect(currVal, $productContainer);
            }

            // Disable add to cart.
            $('.buyContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
            $('.rentContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
        });

        var selectedSize = $('.select-size');
        if (selectedSize.length > 0) {
            $('.select-size').trigger('change');
        }
    },
    customizelook: function () {

        $('.js-add-to-look').on('click', function(e) {
            e.preventDefault();

            var $this = $(this);
            var url = $this.attr('href');
            var purchaseOption = $('.purchase-option .option-btn.active').data('value');
            var urlParams = {
                purchaseOption: purchaseOption
            };

            url = urlHelper.appendToUrl(url, urlParams);

            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    if (data.redirectUrl) {
                        window.location = data.redirectUrl;
                    } else {
                        getModalHtmlElement();
                        var parsedHtml = $(data.renderedTemplate);

                        $('#confirmFavoriteViewModal .modal-body').empty();
                        $('#confirmFavoriteViewModal .modal-body').html(parsedHtml);
                        $('#confirmFavoriteViewModal').modal('show');
                    }
                },
                error: function () {
                    window.location.reload();
                }
            });
        });

        var prodTitle = $('.content-pdp-rent .product-name').text().split(' ');
        var lowerCaseTitle = '';

        for (var i = 0; i < prodTitle.length; i++) {
            lowerCaseTitle += ' ' + prodTitle[i].toLowerCase();
        }

        $('.content-pdp-rent .product-name').text(lowerCaseTitle);

        var childOptionLength = $('.purchase-option').children().length;

        setTimeout(function() {
            if (childOptionLength === 1) {
                $('.purchase-option .option-btn')
                    .click()
                    .addClass('shadow-none')
                    .addClass('active');
            }
        }, 100);

        $(document).on('click', '.ecom-buttons-container .options-container .option-btn', (e)=> {
            var $this = $(e.currentTarget),
                data = $this.attr('data-type');

            $('.ecom-buttons-container .options-container .option-btn')
                .attr('aria-checked', false)
                .removeClass('active');

            $this
                .attr('aria-checked', true)
                .addClass('active');

            if (data === 'buyContainer') {
                $('.buyContainer').addClass('active');
                $('.rentContainer').removeClass('active');
            } else if (data === 'rentContainer') {
                $('.rentContainer').addClass('active');
                $('.buyContainer').removeClass('active');
            }
        });

        $(document).on('click', '.customize-button', () => {
            $('.look-builder-main-container').addClass('active');
            $('.content-pdp-rent').removeClass('active');
            $('[data-action="Product-Show"] .notification-bar-header').addClass('d-none');
            $('[data-action="Product-Show"] .container-fluid').addClass('d-none');
            $('[data-action="Product-Show"] .how-it-works-container').addClass('d-none');
            $('[data-action="Product-Show"] #footercontent').addClass('d-none');
            $('[data-action="Product-Show"] .close-builder-btn-container').addClass('active');
            $('[data-action="Product-Show"] .carousel-container .d-md-block').addClass('active');
            $('[data-action="Product-Show"] .bread-crumb-container').addClass('d-none');
            $('[data-action="Product-Show"] .look-builder-logo-container').removeClass('d-none');
            $('[data-action="Product-Show"] .carousel-container .social-icons-container').addClass('d-none');
            $('[data-action="Product-Show"] .carousel-container').addClass('justify-content-center');
            $('[data-action="Product-Show"] .product-detail').addClass('active');
            $('[data-action="Product-Show"] .aditional-item-thumbnail-container').addClass('active');
            $('[data-action="Product-Show"] .zoom-icon').addClass('active');
        });

        $('.close-builder-btn').on('click', (e)=> {
            var $this = $(e.currentTarget);

            $this.parent().removeClass('active');
            $('.look-builder-main-container').removeClass('active');
            $('.content-pdp-rent').addClass('active');
            $('[data-action="Product-Show"] .notification-bar-header').removeClass('d-none');
            $('[data-action="Product-Show"] .container-fluid').removeClass('d-none');
            $('[data-action="Product-Show"] .how-it-works-container').removeClass('d-none');
            $('[data-action="Product-Show"] #footercontent').removeClass('d-none');
            $('[data-action="Product-Show"] .carousel-container .d-md-block').removeClass('active');
            $('[data-action="Product-Show"] .bread-crumb-container').removeClass('d-none');
            $('[data-action="Product-Show"] .bread-crumb-container').removeClass('d-none');
            $('[data-action="Product-Show"] .look-builder-logo-container').addClass('d-none');
            $('[data-action="Product-Show"] .carousel-container .social-icons-container').removeClass('d-none');
            $('[data-action="Product-Show"] .carousel-container').removeClass('justify-content-center');
            $('[data-action="Product-Show"] .product-detail').removeClass('active');
            $('[data-action="Product-Show"] .aditional-item-thumbnail-container').removeClass('active');
            $('[data-action="Product-Show"] .zoom-icon').removeClass('active');
        });

        $('.add-items-container .selection-option').on('click', ()=> {
            $('.look-builder-main-container .options-container').addClass('active');
            $('.look-builder-main-container .look-rent-menu').removeClass('active');
        });

        $('.options-container .filter-container .category-label .back-btn, .options-container .filter-container .category-label .close-btn, .look-builder-main-container .btn-container .add-look').on('click', ()=> {
            $('.look-builder-main-container .options-container').removeClass('active');
            $('.look-builder-main-container .look-rent-menu').addClass('active');
        });

        $('.list-item').on('click', (e)=> {
            var $this = $(e.currentTarget);

            $('.list-item .secondary-btn').removeClass('active');
            $('.list-item .secondary-btn').text('Select');
            $('.look-builder-list-item-container .list-item').removeClass('active');
            $('.look-builder-modal-container').addClass('active');
            $this.addClass('active');
            // $this.text('Current Selection');

            if ($('.look-builder-main-container .additional-options .list-item').hasClass('active')) {
                $('.btn-container .add-look').removeClass('disabled');
                $('.btn-container .add-look').prop('disabled', false);
            } else {
                $('.btn-container .add-look').prop('disabled', true);
                $('.btn-container .add-look').addClass('disabled');
            }
        });
    }
};
